import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, PopoverController } from '@ionic/angular/standalone';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from '@v-locker-app/v-locker-common';
import moment from 'moment/moment';
import { AppConfig } from 'src/app/config/routes.config';
import { StorageService } from 'src/app/core/services/storage.service';
import { NewsDetailsPage } from 'src/app/modules/home-wrapper/news/news-details/news-details.page';
import { CustomNotificationDTO, GroupedNotification } from 'src/shared/components/elements/notifications/notifications.component';
import { StorageEnums, BookingStatus } from 'src/shared/models/enums';
import { DateHelperService } from './date-helper.service';

export enum NotificationType {
	BOX_IS_OPEN_TOO_LONG = 'BOX_IS_OPEN_TOO_LONG',
	MSP_ORDER = 'MSP_ORDER',
	MANUAL = 'MANUAL',
	NEWS = 'NEWS'
}

@Injectable({
	providedIn: 'root'
})
export class PushNotificationHelperService {
	private routes = AppConfig.routes;

	constructor(private router: Router,
				private storage: StorageService,
				private modalCtrl: ModalController,
				private popOver: PopoverController,
				private translateService: TranslateService,
				private alert: AlertService) {
	}


	public async showAlert(title, body, type: NotificationType, id = null, showPopup = false, showContinueBtn = true) {
		console.log('showAlert', id);
		
		if (showPopup) {
			await this.alert.oneButtonsAlertFromPush(type, async () => {
				const item = await this.storage.getItem(StorageEnums.DoorStatusOpened);
				// if (type === NotificationType.BOX_IS_OPEN_TOO_LONG && item) {
				// 	return;
				// }
				await this.navigateTo(type, id);
			}, body, title, showContinueBtn);
		} else {
			await this.navigateTo(type, id);
		}
	}

	private async navigateTo(type: NotificationType, id?: number) {
		const item = await this.storage.getItem(StorageEnums.DoorStatusOpened);
		// if (type === NotificationType.BOX_IS_OPEN_TOO_LONG && item) {
		// 	return;
		// }

		const urlAndParams = this.getUrlAndParams(type, id);
		if (type) {
			if(urlAndParams.url) {
				this.popOver.dismiss();
				await this.router.navigate(urlAndParams.url, {
					queryParams: urlAndParams.params,
					queryParamsHandling: 'merge'
				});
			}
			else if(urlAndParams.component) {
				await this.popOver.dismiss();
				const modal = await this.modalCtrl.create({
					id: 'booking-details',
					component: urlAndParams.component,
					cssClass: 'auto-height',
					componentProps: {
						id: urlAndParams.id
					}
				});
				modal.present();
			}
		}
	}

	private getUrlAndParams(type: NotificationType, id?: number) {
		const data = { url: null, component: null, params: null, id: null };
		switch (type) {
			case NotificationType.BOX_IS_OPEN_TOO_LONG:
				data.url = [this.routes.home.fullPath];
				data.params = {
					bookingId: id,
					step: BookingStatus.OpenDoors,
					trigger: new Date().toString()
				};
				break;
			case NotificationType.MSP_ORDER:
				// data.component = ['/' + this.routes.orderDetails.fullPath, id];
				break;
			case NotificationType.MANUAL:
				data.component = ['/' + this.routes.profile.notificationsPage.fullPath];
				break;
			case NotificationType.NEWS:
				data.component = NewsDetailsPage;
				data.id = id;
				break;
		}

		return data;
	}

	/**
	 * Group notifications by date
	 */
	groupNotificationsByDate(notifications: Array<CustomNotificationDTO>) {
		const uniqValues: Set<string> = new Set<string>();
		notifications.forEach(n => {
			const date = moment(n.createdDate).format('yyyy-MM-D');
			let key = date;
			const isToday = DateHelperService.isSameDateAsCurrent(n.createdDate, 'day');
			const isYesterday = DateHelperService.isYesterday(n.createdDate, 'day');
			if (isToday) {
				key = this.translateService.instant('notifications.today');
			}
			if (isYesterday) {
				key = this.translateService.instant('notifications.yesterday');;
			}

			n.groupDate = key;
			uniqValues.add(key);
		});

		const result: Array<GroupedNotification> = [];
		let result2: Array<CustomNotificationDTO> = [];
		uniqValues.forEach(uv => {
			const filtered = notifications.filter(n => n.groupDate === uv);
			result.push({
				name: uv,
				list: filtered
			});

			const c: any = {};
			result2.push({
				...c,
				...{
					name: uv,
					dateTitle: true
				}
			});
			result2 = [...result2, ...filtered];
		});

		result2.forEach(n => {
			n.clazz = n.status !== 'READ' && !n.dateTitle ? 'unread' :
				n.status === 'READ' ? 'read' : n.dateTitle ? 'date-title' : '';
		});

		return result2;
	}
}
